import { ContactFormExpert } from '@sapientpro/sapientpro-data-models/src/components/shared/contact-form-expert';
import { atom } from 'jotai';

const contactModalTriggerButton = atom<null | string>(null);
export const contactExpert = atom<ContactFormExpert | null>(null);
export const defaultContactExpert = atom<ContactFormExpert | null>(null);

export default contactModalTriggerButton;
